const s = (o) => {
  const { links: r = [], right_section: e = {} } = o || {}, n = r.map((t) => ({
    title: t.text,
    href: t.url,
    target: t == null ? void 0 : t.target
  })), a = [];
  return Object.keys(e).forEach((t) => {
    if (typeof e[t] == "string") {
      const c = {
        label: e[t]
      };
      a.push(c);
    }
  }), {
    linkData: {
      leftSection: n,
      rightSection: a
    },
    componentType: "top_navigation"
  };
};
export {
  s as default
};
//# sourceMappingURL=siteNavigationTransformer.js.map
